function ecostalSignupForm() {
    const form = document.querySelector('#ecostal-signup-form');
    // Get API base URL from data attribute
    const apiBaseUrl = form.getAttribute('data-api-base-url');
    const companyDataWrapper = form.querySelector('#company-data-wrapper');
    const companyRegistrationTypeSelector = form.querySelector('#company-registration-type-selector');
    const companyField = form.querySelector('#company');
    const addressField = form.querySelector('#address');
    const zipField = form.querySelector('#zip');
    const cityField = form.querySelector('#city');
    const countryCodeField = form.querySelector('#company_country_code');
    const confirmed = form.querySelector('#confirmed');
    const errorWrapper = form.querySelector('#error-wrapper');
    const formLoader = document.querySelector('.js-loader');
    let companyRegistrationNumberType = 'vat';

    // Check if the ecostal website has the possibility to offer siret registration number as an alternative to vat number, if yes, add a checkbox to allow users to select it and adapt the form accordingly
    if (companyRegistrationTypeSelector) {
        const vatInput = form.querySelector('#vat');

        // Create and insert a 'VAT not available' checkbox button after VAT input
        if (vatInput) {
            const siretWrapper = document.createElement('div');
            siretWrapper.className = 'custom-checkbox--secondary custom-checkbox--secondary--siret-alternative';

            const siretRadio = document.createElement('div');
            siretRadio.className = 'custom-checkbox custom-checkbox--dark';
            siretRadio.innerHTML = `<input type="checkbox" id="number_type_siret_alternative" name="company_registration_number_type_alternative" value="siret"><label for="number_type_siret_alternative"><span>${window.translations.form.vat_not_available}</span></label>`;

            siretWrapper.appendChild(siretRadio);

            // Insert after the VAT input element
            vatInput.parentNode.insertBefore(siretWrapper, vatInput.nextSibling);

            // Add event listener to the checkbox
            const siretCheckbox = siretWrapper.querySelector('#number_type_siret_alternative');
            siretCheckbox.addEventListener('change', (event) => {
                if (event.target.checked) {
                    companyRegistrationNumberType = 'siret';
                    form.querySelector('#vat').setAttribute('disabled', 'disabled');
                    form.querySelector('#vat').removeAttribute('required');
                    form.querySelector('#siret').setAttribute('required', 'required');
                    form.querySelector('#siret').parentElement.style.display = 'block';
                } else {
                    companyRegistrationNumberType = 'vat';
                    form.querySelector('#vat').removeAttribute('disabled');
                    form.querySelector('#vat').setAttribute('required', 'required');
                    form.querySelector('#siret').removeAttribute('required');
                    form.querySelector('#siret').parentElement.style.display = 'none';
                }
            });
        }
    }

    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        let mainActivities = document.querySelectorAll('input[name="main_activity[]"]:checked');
        let interests = document.querySelectorAll('input[name="interests[]"]:checked');

        if (mainActivities.length === 0) {
            showCheckboxRequiredFormError(errorWrapper, "NO_ACTIVITIES", form, 'activities');
            return;
        }
        if (interests.length === 0) {
            showCheckboxRequiredFormError(errorWrapper, "NO_INTERESTS", form, 'interests');
            return;
        }

        if (confirmed.value === "true") {
            form.classList.add('js-loading');
            formLoader.classList.add('js-show');
            formLoader.classList.add(`js-show-${companyRegistrationNumberType}`);

            const leadFormPayload = {
                language: form.querySelector('#language').value,
                first_name: form.querySelector('#first_name').value,
                last_name: form.querySelector('#last_name').value,
                email: form.querySelector('#email').value,
                phone_number: form.querySelector('#phone_number').value,
                company_registration_number_type: companyRegistrationNumberType,
                vat: form.querySelector('#vat')?.value || '',
                siret: form.querySelector('#siret')?.value || '',
                main_activity: Array.from(document.querySelectorAll('input[name="main_activity[]"]:checked')).map(el => el.value),
                interests: Array.from(document.querySelectorAll('input[name="interests[]"]:checked')).map(el => el.value),
                sector: form.querySelector('input[name="sector"]:checked')?.value || '',
                company: companyField.value,
                address: addressField.value,
                city: cityField.value,
                zip: zipField.value,
                company_country_code: countryCodeField.value,
            };

            try {
                const leadformResponse = await fetch(`${apiBaseUrl}/leadform`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(leadFormPayload),
                });

                const leadformData = await leadformResponse.json();

                if (leadformData.success) {
                    // Hide the form and loader
                    form.classList.remove('js-loading');
                    form.style.display = 'none';
                    formLoader.classList.remove('js-show');
                    formLoader.classList.remove('js-show-vat');
                    formLoader.classList.remove('js-show-siret');
                    
                    // Show success message
                    const successMessage = document.querySelector('.js-signup-success-message');
                    if (successMessage) {
                        successMessage.style.display = 'block';
                    }
                } else {
                    showEcostalSignupFormError(errorWrapper, leadformData.error || 'error', form, companyRegistrationNumberType);
                    form.classList.remove('js-loading');
                    formLoader.classList.remove('js-show');
                    formLoader.classList.remove('js-show-vat');
                    formLoader.classList.remove('js-show-siret');
                }
            } catch (error) {
                showEcostalSignupFormError(errorWrapper, 'error', form, companyRegistrationNumberType);
                form.classList.remove('js-loading');
                formLoader.classList.remove('js-show');
                formLoader.classList.remove('js-show-vat');
                formLoader.classList.remove('js-show-siret');
            }
        } else {
            companyDataWrapper.style.display = 'none'; // Show the address field
            errorWrapper.style.display = 'none';
            let companyRegistrationNumber = form.querySelector(`#${companyRegistrationNumberType}`).value.trim().toUpperCase();

            if (!companyRegistrationNumber) {
                showEcostalSignupFormError(errorWrapper, "error", form, companyRegistrationNumberType);
            }

            try {
                form.classList.add('js-loading');
                formLoader.classList.add('js-show');
                formLoader.classList.add(`js-show-${companyRegistrationNumberType}`);
                // Use API base URL from data attribute
                const apiUrl = `${apiBaseUrl}/validate-vat`;
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ company_registration_number: companyRegistrationNumber, company_registration_number_type: companyRegistrationNumberType })
                });

                const data = await response.json();

                if (data.success) {
                    if(data.success === true) {
                        form.classList.add('step-2');
                        form.classList.remove('hidden');
                        form.classList.remove('js-loading');
                    }

                    companyField.value = data.company || '';
                    addressField.value = data.address || '';
                    zipField.value = data.zip || '';
                    cityField.value = data.city || '';
                    countryCodeField.value = data.countryCode || '';
                    confirmed.value = "true";
                    companyDataWrapper.style.display = 'flex';
                    formLoader.classList.remove('js-show');
                    formLoader.classList.remove('js-show-vat');
                    formLoader.classList.remove('js-show-siret');
                    form.classList.remove('hidden');
                    form.classList.remove('js-loading');
                } else {
                    showEcostalSignupFormError(errorWrapper, data.error, form, companyRegistrationNumberType);
                    form.classList.remove('step-2');
                    formLoader.classList.remove('js-show');
                    formLoader.classList.remove('js-show-vat');
                    formLoader.classList.remove('js-show-siret');
                    form.classList.remove('hidden');
                    form.classList.remove('js-loading');
                }
            } catch (error) {
                showEcostalSignupFormError(errorWrapper, "There was an error", form, companyRegistrationNumberType);
                form.classList.remove('step-2');
                formLoader.classList.remove('js-show');
                formLoader.classList.remove('js-show-vat');
                formLoader.classList.remove('js-show-siret');
                form.classList.remove('hidden');
                form.classList.remove('js-loading');
            }
        }
    });

    document.querySelector('.js-button-back').addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default button behavior
        const form = document.querySelector('#ecostal-signup-form');
        const companyDataWrapper = form.querySelector('#company-data-wrapper');
        const errorWrapper = form.querySelector('#error-wrapper');
        const confirmed = form.querySelector('#confirmed');
        resetEcostalSignupForm(form, companyDataWrapper, errorWrapper, confirmed);
    });

    removeErrorOnInput(form);
}

function resetEcostalSignupForm(form, companyDataWrapper, errorWrapper, confirmed) {
    const inputs = form.querySelectorAll('input');
    companyDataWrapper.style.display = 'none'; // Hide company data wrapper
    errorWrapper.style.display = 'none'; // Hide error messages
    confirmed.value = "false"; // Reset the confirmed value
    form.classList.remove('step-2'); // Revert to the initial step
    inputs.forEach((input) => {
        input.classList.remove('error'); // Remove error class from the input
        form.classList.remove('form-error', 'form-error-all'); // Remove error-related classes from the form
    });
}

function removeErrorOnInput(form) {
    const inputs = form.querySelectorAll('input');
    const errorWrapper = form.querySelector('#error-wrapper');

    inputs.forEach((input) => {
        input.addEventListener('input', () => {
            if (input.classList.contains('error')) {
                input.classList.remove('error'); // Remove error class from the input
                form.classList.remove('form-error', 'form-error-all'); // Remove error-related classes from the form
            }
            errorWrapper.style.display = 'none';
        });
    });
}

function showEcostalSignupFormError(errorWrapper, error, form, type='vat') {
    const vatField = form.querySelector('#vat');
    const siretField = form.querySelector('#siret');
    let companyRegistrationNumberField = '';

    if (type === 'vat') {
        companyRegistrationNumberField = vatField
    }
    if (type === 'siret') {
        companyRegistrationNumberField = siretField
    }

    errorWrapper.style.display = 'block';

    if (error === "WRONG_FORMAT") {

        if (type === 'vat') {
          errorWrapper.innerHTML = `<p>${window.translations.form.wrong_format_vat}</p>`;
        }
        if (type === 'siret') {
          errorWrapper.innerHTML = `<p>${window.translations.form.wrong_format_siret}</p>`;
        }
        form.classList.add('form-error');
        companyRegistrationNumberField.classList.add('error');
    } else if (error === "COMPANY_NOT_FOUND") {
        errorWrapper.innerHTML = `<p>${window.translations.form.company_not_found}</p>`;
        form.classList.add('form-error');
        companyRegistrationNumberField.classList.add('error');
    } else if (error === "COMPANY_ALREADY_EXISTS") {
        errorWrapper.innerHTML = `<p>${window.translations.form.company_already_exists}</p>`;
        form.classList.add('form-error');
        companyRegistrationNumberField.classList.add('error');
    } else if (error === "VIES_API_ERROR") {
        errorWrapper.innerHTML = `<p>${window.translations.form.vies_api_error}</p>`;
        form.classList.add('form-error');
        companyRegistrationNumberField.classList.add('error');
    }  else {
        form.classList.add('form-error');
        form.classList.add('form-error-all');
        errorWrapper.innerHTML = `<p>${window.translations.form.other_error}</p>`;
    }
}

function showCheckboxRequiredFormError(errorWrapper, error, form, type = 'activities') {
    const activitiesFields = document.querySelectorAll('input[name="main_activity[]"]');
    const interestsFields = document.querySelectorAll('input[name="interests[]"]');
    let checkboxFields = '';

    if (type === 'activities') {
        checkboxFields = activitiesFields
    }
    if (type === 'interests') {
        checkboxFields = interestsFields
    }

    errorWrapper.style.display = 'block';

    if (error === "NO_ACTIVITIES") {
        errorWrapper.innerHTML = `<p>${window.translations.form.no_activities_selected}</p>`;
        form.classList.add('form-error');
        checkboxFields.forEach(el => el.classList.add('error'));
    } else if (error === "NO_INTERESTS") {
        errorWrapper.innerHTML = `<p>${window.translations.form.no_interests_selected}</p>`;
        form.classList.add('form-error');
        checkboxFields.forEach(el => el.classList.add('error'));
    }
}

ecostalSignupForm();


